import { createFileRoute } from '@tanstack/react-router';

import { CookiePolicyPage } from '~/components/legal/CookiePolicyPage';

const CookiePolicy = () => {
  return <CookiePolicyPage />;
};

export const Route = createFileRoute('/$locale/cookies')({
  component: CookiePolicy,
});
